/* eslint @typescript-eslint/strict-boolean-expressions: off */

import cn from "classnames";
import styles from "gui/spacer/spacer.module.css";
import { Size } from "gui/theme/theme";

export const Spacer: React.FC<{
  size?: Size;
  at?: Size;
}> = (props) => {
  const className = cn(
    styles.spacer,
    props.at && styles[`at-${props.at}`],
    props.size && styles[props.size]
  );

  return <div className={className} aria-hidden />;
};
